module.exports = __webpack_public_path__ + "fb6ef33f3d4e52127d7a8e39be03751a.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/body/cello.png
// module id = 1821
// module chunks = 0